/**
 * Navigation Component
 * Handles mobile menu toggle functionality
 */

export default class Navigation {
    constructor() {
        this.mobileMenuBtn = document.getElementById('mobileMenuBtn');
        this.sidebar = document.getElementById('sidebar');
        this.profileDropdown = document.getElementById('profileDropdown');
        this.init();
    }

    init() {

        // Mobile menu toggle
        if (this.mobileMenuBtn && this.sidebar) {

            this.mobileMenuBtn.addEventListener('click', () => this.toggleMobileMenu());
        }

        // Close mobile menu when clicking outside
        document.addEventListener('click', (e) => {
            if (this.sidebar && !this.sidebar.contains(e.target) && !this.mobileMenuBtn.contains(e.target)) {
                this.closeMobileMenu();
            }
        });

        // Close profile dropdown when clicking outside
        document.addEventListener('click', (e) => {
            if (this.profileDropdown && !this.profileDropdown.parentElement.contains(e.target)) {
                this.profileDropdown.classList.add('hidden');
            }
        });
    }

    toggleMobileMenu() {

        this.sidebar.classList.toggle('hidden');
        this.sidebar.classList.toggle('flex');

        // Add mobile-specific classes when showing
        if (!this.sidebar.classList.contains('hidden')) {
            this.sidebar.classList.add('fixed', 'z-40', 'inset-y-0', 'left-0', 'mt-16');
        }
    }

    closeMobileMenu() {
        if (this.sidebar && !this.sidebar.classList.contains('lg:flex')) {
            this.sidebar.classList.add('hidden');
            this.sidebar.classList.remove('flex');
        }
    }
}
